import React from "react";

function Footer() {
  return (
    <>
      <div >
        <div className="col-main  flex flex-col lg:flex-row justify-around items-start footer-column gap-20 mx-12 md:mx-48 my-24">
          <div className="colmouns flex flex-col items-inherit md:items-between gap-3 w-full flex-1">
            <h3 className="heading text-base md:text-md  leading-6 text-slate-700 font-bold">
              Browse
            </h3>
            <div className=" flex gap-2 md:gap-20 "> 
              <ul className="flex flex-col justify-start gap-2">
                <li className="text-base md:text-md  leading-6 text-slate-400">
                  Streaming Library
                </li>
                <li className="text-base md:text-md  leading-6 text-slate-400">Live TV</li>
                <li className="text-base  md:text-md leading-6 text-slate-400">Live News</li>
                <li className="text-base  md:text-md leading-6 text-slate-400">
                  Live Sports
                </li>
              </ul>

              <ul className="flex flex-col justify-start gap-2">
                <li className="text-base  md:text-md leading-6 text-slate-400">
                  Streaming Library
                </li>
                <li className="text-base  md:text-md leading-6 text-slate-400">Live TV</li>
                <li className="text-base md:text-md  leading-6 text-slate-400">Live News</li>
                <li className="text-base md:text-md  leading-6 text-slate-400">
                  Live Sports
                </li>
                <li className="text-base md:text-md leading-6 text-slate-400">Live News</li>
                <li className="tex-base md:text-md leading-6 text-slate-400">
                  Live Sports
                </li>
              </ul>

              <ul className="flex flex-col justify-start gap-2">
                <li className="tex-base md:text-md leading-6 text-slate-400">
                  Streaming Library
                </li>
                <li className="tex-base md:text-md leading-6 text-slate-400">Live TV</li>
                <li className="tex-base md:text-md leading-6 text-slate-400">Live News</li>
                <li className="tex-base md:text-md leading-6 text-slate-400">
                  Live Sports
                </li>
              </ul>
            </div>
          </div>
          <div className="colmouns flex flex-col justify-start gap-3">
            <h3 className="heading text-base md:text-md leading-6 text-slate-700 font-bold">
              Browse
            </h3>
            <ul className="flex flex-col justify-start gap-1 md:gap-2">
              <li className="text-base md:text-md leading-6 text-slate-400">
                Streaming Library
              </li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live TV</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live News</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live Sports</li>
            </ul>
          </div>
          <div className="colmouns flex flex-col justify-start gap-3">
            <h3 className="heading text-base md:text-md leading-6 text-slate-700 font-bold">
              Browse
            </h3>
            <ul className="flex flex-col justify-start gap-1 md:gap-2">
              <li className="text-base md:text-md leading-6 text-slate-400">
                Streaming Library
              </li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live TV</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live News</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live Sports</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live News</li>
              <li className="text-base md:text-md leading-6 text-slate-400">Live Sports</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
